module.exports = __webpack_public_path__ + "img/15.001459bf.jpg";